import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

export const DEVICE_TARGET_KIND = "device";

export const DEVICES_DOCK_PANEL_ID = "devices";

const DEVICES_BASE_PATH = "/settings/devices";

const DEVICE_ROUTE_PATTERN = /^\/settings\/devices\/([^/?#]+)$/;

export const buildDevicePath = (deviceId: string): string => `${DEVICES_BASE_PATH}/${encodeURIComponent(deviceId)}`;

export const matchDeviceReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const match = DEVICE_ROUTE_PATTERN.exec(pathname);
	return match ? { targetId: decodeURIComponent(match[1]), targetKind: DEVICE_TARGET_KIND } : null;
};

const deviceReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => buildDevicePath(targetId),
	matchesRoute: matchDeviceReceiverRoute
};

export default deviceReceiverIdentityAdapter;
